const API_BASE_URL = 'https://scmapi.lechun.cc/lechun-baseservice/vibeProject/bootstrap'
const API_KEY_PROFILE_URL = 'https://portal.lechun.cc/portal/profile?tab=apikey'

export const VIBE_SPACE_INSTRUCTION_URL = `${API_BASE_URL}/space-instruction`

function apiKeySetupRequirement() {
    return `API Key 只能从当前环境变量 \`LECHUN_API_KEY\` 读取，不要让我粘贴、回显或保存 API Key。
如果环境变量不存在，停止后续操作，让我打开 ${API_KEY_PROFILE_URL}，在页面表格下方按电脑系统复制环境配置命令：Mac 打开“终端”（Terminal）执行，Windows 打开“命令提示符”（CMD）执行；成功后完全退出并重新打开 Codex。`
}

export function buildVibeGitlabCodexPrompt() {
    return `请帮我初始化公司 VibeCoding 空间。

${apiKeySetupRequirement()}

使用请求头 \`X-API-Key: $LECHUN_API_KEY\` 调用下面接口，不得改用 \`X-Caller-Key\`：

\`POST ${VIBE_SPACE_INSTRUCTION_URL}\`

每次执行都必须重新调用接口获取最新内容。检查响应 JSON，只有 \`status=200\` 且 \`success=true\` 才能继续，然后完整执行 \`value.instruction\`。

不要把接口响应原文打印到终端或聊天中，不得在最终回复中输出接口返回的密码、AccessToken 或其他凭据。`
}

export function buildVibeProjectCodexPrompt(projectId) {
    const normalizedProjectId = String(projectId == null ? '' : projectId).trim()
    if (!/^\d+$/.test(normalizedProjectId) || Number(normalizedProjectId) <= 0) {
        throw new Error('projectId must be a positive integer')
    }
    const instructionUrl = `${API_BASE_URL}/projects/${normalizedProjectId}/instruction`
    return `请帮我初始化公司 VibeCoding 项目，项目 ID 为 ${normalizedProjectId}。

${apiKeySetupRequirement()}

使用请求头 \`X-API-Key: $LECHUN_API_KEY\` 调用下面接口，不得改用 \`X-Caller-Key\`：

\`POST ${instructionUrl}\`

每次执行都必须重新调用接口获取该项目的最新提示词。检查响应 JSON，只有 \`status=200\` 且 \`success=true\` 才能继续，然后完整执行 \`value.instruction\`。

不得修改项目 ID，不要把接口响应原文打印到终端或聊天中，不得在最终回复中输出接口返回的数据库密码、Token 或其他凭据。`
}
